import React, { useState } from 'react';
import { Dialog ,IconButton, DialogContent ,DialogTitle ,DialogActions ,CircularProgress ,TextField ,Box ,Typography ,Button, Grid,Card, CardContent, Divider , MenuItem ,Select, InputLabel, InputAdornment } from '@mui/material';
import UserProfileContainer from './print';
import HeightBox from '../components/HeightBox';
import { Editor, EditorState } from 'draft-js';
import AddIcon from '@material-ui/icons/Add';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FileList from './fileList.';
import { useSelector, useDispatch } from 'react-redux';
import { selectRegNumber } from '../../../actions/fileActions';
import CandidateService from '../../../services/candidateService';
import Options from '../../../screens/OptionsManage';
import CustomSelect from './CustomSelect';
import CurrencyInput from '../components/CurrencyInput';
import { setSelectedURLs } from '../../../actions/fileActions';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Ai from "./openAi";


const theme = createTheme({

  typography: {
    fontSize: 10, // Adjust the default font size
  },

  components: {
    // Customize the component sizes
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#edf8ff", // Replace "#FF0000" with your desired color
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the button font size
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the text field font size
          height: 30, // Adjust the text field height
          size: "small", // Adjust the text field height
          boxSizing: "inherit", // Adjust the text field height
        },
      },
    },
    // Add other components here with their desired customizations
  },
});





const CreateCandidateForm = () => {

  const dispatch = useDispatch();
  const [regNumber, setRegNumber] = useState('');

  

  const [options, setOptions] = useState({});
  


const handleAddCustomStream = (customStream, fieldName) => {
  // Check if the customStream is not empty and is not already present in the options array based on the fieldName
  if (customStream && !options[fieldName].includes(customStream)) {
    // Create a new array by combining the original options array and the customStream
    const updatedOptions = {
      ...options,
      [fieldName]: [...options[fieldName], customStream],
    };

    // Update the state or perform any other necessary actions with the updatedOptions object
    setOptions(updatedOptions);
  }
};


const fetchOptions = async () => {
  try {
    const response = await CandidateService.getAllOptions();
    const data = response.data;

    const groupedOptions = {};
    data.forEach(option => {
      const { fieldName, label, value } = option;
      if (groupedOptions.hasOwnProperty(fieldName)) {
        groupedOptions[fieldName].push({ label, value });
      } else {
        groupedOptions[fieldName] = [{ label, value }];
      }
    });

    setOptions(prevOptions => ({
      ...prevOptions,
      ...groupedOptions
    }));
  } catch (error) {
    console.error('Error fetching options:', error);
  }
};




  const [formValues, setFormValues] = useState({
    regNumber: '',
    fullName: '',
    dob: '',
    age: 0,
    nic: '',
    gender: '',
    civilStatus: '',
    availability: '',
    appliedFor: '',
    personalInfo: {
      nationality: ''
    },
    educationalQualification: [
      {
        degree: '',
        university: '',
        start: '',
        complete: ''
      }
    ],
    higherEducationalQualification: [
      {
        degree: '',
        university: '',
        start: '',
        complete: '',
        prefix: '',
      }
    ],
    professionalQualification: [
      {
        certification: '',
        organization: '',
        start: '',
        complete: ''
      }
    ],
    professionalMembership: [
      {
        membership: '',
        organization: '',
        start: '',
        complete: '',
        number: ''
      }
    ],
    workExperience: [
      {
        company: '',
        start: '',
        end: '',
        description: ''
      }
    ],
    otherQualification:{
      educationalQualification: [],
      higherEducationalQualification: [],
      professionalQualification: [],
      professionalMembership: [],
      workExperience: [],
      softSkills: [],
      hardSkills: [],
    },
    
    profileAttached: '',
    images: {
      passportSize: '',
      fullSize: ''
    }
  });

  React.useEffect(() => {
    console.log("Hi")
    fetchOptions();
    dispatch(selectRegNumber(formValues.regNumber));
  }, [formValues]);
  
  const [step, setStep] = useState(1);
  const [files, setFiles] = useState([{}]);
  const [professionalSummary, setProfessionalSummary] = useState('');

  const fetchFiles = async () => {
    try {
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch(`https://oseas-api.hypen.lk/api/v1/candidates/files/${regNumber}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        console.log(data);
        setFiles(data);

      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  const softSkills = ['Communication', 'Teamwork', 'Problem Solving', 'Leadership', 'Adaptability'];
  const handleSoftSkillClick = (softSkill) => {
    // handleInputChange(value, 'softSkills')}
    const updatedValue = formValues.otherQualification.softSkills + softSkill;
    handleInputChange(updatedValue,'softSkills');
  };

  const renderSoftSkills = () => {
    return softSkills.map((softSkill) => (
      <button key={softSkill} onClick={() => handleSoftSkillClick(softSkill)}>
        {softSkill}
      </button>
    ));
  };

  const hardSkills = ['Programming', 'Data Analysis', 'Project Management', 'Technical Writing', 'Critical Thinking'];
  const handleHardSkillClick = (hardSkill) => {
    // handleInputChange(value, 'softSkills')}
    const updatedValue = formValues.otherQualification.hardSkills + hardSkill;
    handleInputChange(updatedValue,'hardSkills');
  };

  const renderHardSkills = () => {
    return hardSkills.map((hardSkill) => (
      <button key={hardSkill} onClick={() => handleHardSkillClick(hardSkill)}>
        {hardSkill}
      </button>
    ));
  };

  const handleChange = (e, index, field) => {
    
    var { name, value } = e.target;

    let transformedValue = value;
  
    if (name === "nic") {
      value = value.toUpperCase(); // Convert value to uppercase
    }

  


    if (name === 'dob') {
      // Calculate age based on the entered date of birth
      const today = new Date();
      const dob = new Date(value);
      const age = today.getFullYear() - dob.getFullYear();
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        age: age.toString(),
      }));
    }
    
    if(name === 'regNumber'){
      console.log(value)
      if (value.includes(" ")) {
        alert("Spaces are not allowed in the Registration Number field.");
        return;
      }

      let sanitizedValue = value.replace(/s/g, ""); // Remove the letter 's' from the input value
      console.log(sanitizedValue)
      // Update the form values with the sanitized value
      setFormValues((prevValues) => ({
        ...prevValues,
        regNumber : sanitizedValue,
      }));
    };
    

    if (field === 'educationalQualification') {
      const updatedEducationalQualification = [...formValues.educationalQualification];
      updatedEducationalQualification[index][name] = value;
  
      setFormValues((prevValues) => ({
        ...prevValues,
        educationalQualification: updatedEducationalQualification
      }));
    } else if (field === 'higherEducationalQualification') {
      const updatedHigherEducationalQualification = [...formValues.higherEducationalQualification];
      updatedHigherEducationalQualification[index][name] = value;
  
      setFormValues((prevValues) => ({
        ...prevValues,
        higherEducationalQualification: updatedHigherEducationalQualification
      }));
    }
    else if (field === 'professionalQualification') {
      const updatedProfessionalQualification = [...formValues.professionalQualification];
      updatedProfessionalQualification[index][name] = value;

      setFormValues((prevValues) => ({
        ...prevValues,
        professionalQualification: updatedProfessionalQualification
      }));

      const professionalSummary = updatedProfessionalQualification
      .map((qualification) => `${qualification.course}`)
      .join(', ');

      setProfessionalSummary(professionalSummary);
      formValues.personalInfo.professionalSummary = professionalSummary;

    }  else if (field === 'professionalMembership') {

      const updatedProfessionalMembership = [...formValues.professionalMembership];
      updatedProfessionalMembership[index][name] = value;

      setFormValues((prevValues) => ({
        ...prevValues,
        professionalMembership: updatedProfessionalMembership
      }));

    } 
    
    else if (field === 'workExperience') {
      const updatedWorkExperience = [...formValues.workExperience];
      updatedWorkExperience[index][name] = value;

      setFormValues((prevValues) => ({
        ...prevValues,
        workExperience: updatedWorkExperience
      }));
    }  else if (field === 'personalInfo') {
      setFormValues((prevValues) => ({
        ...prevValues,
        personalInfo: {
          ...prevValues.personalInfo,
          [name]: value
        }
      }));
    } else {

      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: value
      }));

    }
    console.log(formValues)
  };

  const [searching, setSearching] = useState(false);
  const handleSearch = async () => {
    console.log('searching');
    setSearching(true);
    dispatch(setSelectedURLs([]));
    try {

      const response = await CandidateService.searchCandidate(regNumber);
      setFormValues(response.data);
      console.log(response.data)
      setSearching(false);
      setStep(2);
     
    } catch (error) {
      console.error('Request failed:', error.message);
      setSearching(false);
    }
    fetchFiles();
    dispatch(selectRegNumber(regNumber));
   };

  const handleAddItem = (field) => {
    if (field === 'educationalQualification') {
      setFormValues((prevValues) => ({
        ...prevValues,
        educationalQualification: [
          ...prevValues.educationalQualification,
          {
            degree: '',
            university: '',
            start: '',
            complete: ''
          }
        ]
      }));
    } else if (field === 'professionalQualification') {
      setFormValues((prevValues) => ({
        ...prevValues,
        professionalQualification: [
          ...prevValues.professionalQualification,
          {
            certification: '',
            organization: '',
            start: '',
            complete: ''
          }
        ]
      }));
    } else if (field === 'workExperience') {
      setFormValues((prevValues) => ({
        ...prevValues,
        workExperience: [
          ...prevValues.workExperience,
          {
            company: '',
            start: '',
            end: '',
            description: ''
          }
        ]
      }));
    } else if (field === 'higherEducationalQualification') {
      setFormValues((prevValues) => ({
        ...prevValues,
        higherEducationalQualification: [
          ...prevValues.higherEducationalQualification,
          {
            degree: '',
            university: '',
            start: '',
            complete: '',
            prefix: '',
          }
        ]
      }));
    } else if (field === 'professionalMembership') {
      setFormValues((prevValues) => ({
      ...prevValues,
      professionalMembership: [
        ...prevValues.professionalMembership,
        {
          membership: '',
          institute: '',
          number: '',
        }
      ]
    }));
  }
  };

  const handleRemoveItem = (index, field) => {
    if (field === 'educationalQualification') {
      const updatedEducationalQualification = [...formValues.educationalQualification];
      updatedEducationalQualification.splice(index, 1);
  
      setFormValues((prevValues) => ({
        ...prevValues,
        educationalQualification: updatedEducationalQualification
      }));
    } else if (field === 'professionalQualification') {
      const updatedProfessionalQualification = [...formValues.professionalQualification];
      updatedProfessionalQualification.splice(index, 1);
  
      setFormValues((prevValues) => ({
        ...prevValues,
        professionalQualification: updatedProfessionalQualification
      }));
    } else if (field === 'workExperience') {
      const updatedWorkExperience = [...formValues.workExperience];
      updatedWorkExperience.splice(index, 1);
  
      setFormValues((prevValues) => ({
        ...prevValues,
        workExperience: updatedWorkExperience
      }));
    } else if (field === 'higherEducationalQualification') {
      const updatedHigherEducationalQualification = [...formValues.higherEducationalQualification];
      updatedHigherEducationalQualification.splice(index, 1);
  
      setFormValues((prevValues) => ({
        ...prevValues,
        higherEducationalQualification: updatedHigherEducationalQualification
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a new FormData object
    const formData = new FormData();

    // Append form values to the FormData object
    formData.append('regNumber', formValues.regNumber);
    formData.append('fullName', formValues.fullName);

    // Append other form values here

    // Append the passport size image to the FormData object
    // formData.append('passportSizeImage', passportSizeImage);

    // Handle form submission with the FormData object
    console.log(formData);
  };

  const handleNextStep = () => {
    console.log(step);
    setStep((prevStep) => prevStep + 1);
  };

  const handlePreviousStep = () => {
    setStep((prevStep) => prevStep - 1);
  };


 

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

 
  const handleInputChange = (value, qualificationType) => {
    // const { value } = e
    setFormValues(prevFormValues => ({
      ...prevFormValues,
      otherQualification: {
        ...prevFormValues.otherQualification,
        [qualificationType]: value
      }
    }));
    console.log(formValues);

  };

  

  
  const handleChangeExperienceDescription=(index,value)=>{
    console.log(value)
    var e={
      target:{
        name:'',
        value:''
      }
    };

    e.target.value=value;
    e.target.name='description';

    handleChange(e, index, 'workExperience')
  }

  const sendData = async () => {
  
    const formData = new FormData();
    console.log(formValues)
    formData.append('data', JSON.stringify(formValues));

    try {

      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch('https://oseas-api.hypen.lk/api/v1/candidates', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        alert('Data saved successfully');
            setSearching(true);
            try {
        
              const response = await CandidateService.searchCandidate(regNumber);
              setFormValues(response.data);
              console.log(response.data)
              setSearching(false);
            
            } catch (error) {
              console.error('Request failed:', error.message);
              setSearching(false);
            }
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }

    } catch (error) {
      console.error('Request failed:', error.message);
    }

  };

  return (
    
    <ThemeProvider theme={theme}>
    <Card>
       {
      searching ? (
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}>
          <CircularProgress/>
        </div>
      ):
    
    <CardContent>

    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">{"Candidate Profile"}</DialogTitle>
        <DialogContent>
        <Options/>
        </DialogContent>
    </Dialog>
   
    <form onSubmit={handleSubmit}>
    {step === 1 && (
        
      <Grid container spacing={2} style={{ padding:'10px' }}>
      <Ai/>
      <Grid container spacing={2} style={{ padding:'20px' }}>
        <TextField
          name="regNumber"
          size="small"
          label="Registration Number (DONT USE SPACES BETWEEN NUMBERS AND LETTERS)"
          value={regNumber}
          onChange={(e) => setRegNumber(e.target.value)}
          style={{marginRight: '10px',width:'20%'}}
        />
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={handleSearch}
        >
          Search
        </Button>

        <Divider />
      </Grid>

    <Divider />
    <Typography variant="h6" gutterBottom style={{fontSize:'10px',fontWeight:'bold',marginBottom:20}}> 
      *According to the update on 2023-07-10 You should enter candidate nic to update profiles and upload files
      </Typography>

      <Grid container spacing={2}>

      <Grid item xs={6}>
          <TextField
            name="passportNo"
            size='small'
            label="Passport No."
            value={formValues.passportNo}
            onChange={handleChange}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            name="nic"
            size='small'
            label="Nic No."
            value={formValues.nic}
            onChange={handleChange}
            required
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            name="regNumber"
            size='small'
            disabled={formValues.passportNo===''}
            label="Registration Number"
            value={formValues.regNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

       

        <Grid item xs={6}>
          <TextField
            name="fullName"
            size='small'
            label="Full Name (ALL CAPITAL LETTERS)"
            value={formValues.fullName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

         <Grid item xs={6}>
        <TextField
            name="appliedPosition"
            size='small'
            label="Applied Position (ALL CAPITAL LETTERS)"
            value={formValues.personalInfo.appliedPosition}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>
      

        <Grid item xs={6}>
          <TextField
            name="dob"
            size='small'
            defaultValue='01/01/2023'
            label="Date of Birth"
            type="date"
            value={formValues.dob}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            name="age"
            size='small'
            label="Age"
            value={formValues.age}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
        <TextField
            name="nationality"
            size='small'
            defaultValue='SRI LANKAN'
            label="Nationality (ALL CAPITAL LETTERS)"
            multiline
            value={formValues.personalInfo.nationality}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>

        
      <Grid item xs={6}>
      <InputLabel htmlFor="driving-license">Civil Status</InputLabel>
        <Select
          name="civilStatus"
          size='small'
          label='Civil Status'
          defaultValue='single'
          value={formValues.civilStatus}
          onChange={handleChange}
          fullWidth
          displayEmpty
        >
          <MenuItem value="single">Single</MenuItem>
          <MenuItem value="married">Married</MenuItem>
          <MenuItem value="divorced">Divorced</MenuItem>
          <MenuItem value="widowed">Widowed</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={6}>
      <InputLabel htmlFor="driving-license">Passport</InputLabel>
        <Select
          name="passport"
          size='small'
          label="Passport"
          value={formValues.personalInfo.passport}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        >
          <MenuItem value="AVAILABLE">AVAILABLE</MenuItem>
          <MenuItem value="NOT AVAILABLE">NOT AVAILABLE</MenuItem>
          <MenuItem value="PENDING">PENDING</MenuItem>
        </Select>
        </Grid>
        <Grid item xs={6}>
        <InputLabel htmlFor="driving-license">Driving License</InputLabel>
        <Select
          name="drivingLicense"
          size="small"
          id="driving-license"
          value={formValues.personalInfo.drivingLicense}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        >
          <MenuItem value="AVAILABLE">AVAILABLE</MenuItem>
          <MenuItem value="NOT AVAILABLE">NOT AVAILABLE</MenuItem>
        </Select>
      </Grid>

        <Grid item xs={6}>
        <InputLabel htmlFor="driving-license">Available</InputLabel>
        <Select
            name="availability"
            size='small'
            label='Availability'
            defualtValue='Immediately'
            value={formValues.availability}
            onChange={handleChange}
            fullWidth
          displayEmpty
          >
            <MenuItem value="Immediately">Immediately</MenuItem>
            <MenuItem value="Within a week">Within a week</MenuItem>
            <MenuItem value="Within two weeks">Within two weeks</MenuItem>
            <MenuItem value="Within three weeks">Within three weeks</MenuItem>
            <MenuItem value="After one month notice period">After one month notice period</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={6}>
        <TextField
            name="contact"
            size='small'
            label="Contact No (WhatsApp Available)"
            multiline
            value={formValues.personalInfo.contact}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
        <Select
      name="gender"
      label="Gender"
      value={formValues.gender}
      onChange={handleChange}
      size="small"
      fullWidth
      displayEmpty
    >
      <MenuItem value="">Select</MenuItem>
      <MenuItem value="male">Male</MenuItem>
      <MenuItem value="female">Female</MenuItem>
    </Select>
        </Grid>
        <Grid item xs={6}>
            <TextField
                name="emergencyNumberOneName"
                size='small'
                label="Emergency Contact Person Name (1) (ALL CAPITAL LETTERS)"
                multiline
                value={formValues.personalInfo.emergencyNumberOneName}
                onChange={(e) => handleChange(e, null, 'personalInfo')}
                fullWidth
              />
          </Grid>
        <Grid item xs={3}>
        <TextField
            name="emergencyNumberOne"
            size='small'
            label="Emergency Contact (WhatsApp Available)"
            multiline
            value={formValues.personalInfo.emergencyNumberOne}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
          </Grid>

          <Grid item xs={3}>
        <TextField
            name="emergencyNumberOneRelation"
            size='small'
            label="Relationship (ALL CAPITAL LETTERS)"
            multiline
            value={formValues.personalInfo.emergencyNumberOneRelation}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
          </Grid>

          <Grid item xs={6}>
            <TextField
                name="emergencyNumberTwoName"
                size='small'
                label="Emergency Contact Person Name (2) (ALL CAPITAL LETTERS)"
                multiline
                value={formValues.personalInfo.emergencyNumberTwoName}
                onChange={(e) => handleChange(e, null, 'personalInfo')}
                fullWidth
              />
          </Grid>
        <Grid item xs={3}>
        <TextField
            name="emergencyNumberTwo"
            size='small'
            label="Emergency Contact (WhatsApp Available)"
            multiline
            value={formValues.personalInfo.emergencyNumberTwo}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
          </Grid>

          <Grid item xs={3}>
        <TextField
            name="emergencyNumberTwoRelation"
            size='small'
            label="Relationship (ALL CAPITAL LETTERS)"
            multiline
            value={formValues.personalInfo.emergencyNumberTwoRelation}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
          </Grid>
          

        {/* Add more fields for other form inputs */}
      </Grid>
      {/* ============================================== */}
      {/* Skills */}
      <Grid container spacing={2}>
        <Grid item xs={12}>

          <HeightBox height={10}/>

          <Box    
              sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
            >
                <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
                Skills (Case Sensitive)
              </Typography>
        </Box>
        </Grid>
     
        <Grid item xs={6}>
        <HeightBox height={10} />
        <Typography style={{ fontSize: '16px', color: 'black' }} gutterBottom>
          Soft Skills
        </Typography>
        {renderSoftSkills()}
          <ReactQuill
            value={formValues?.otherQualification?.softSkills || ''}
            onChange={(value) => handleInputChange(value, 'softSkills')}
            // modules={modules}
            // formats={formats}
          />

      </Grid>

      <Grid item xs={6}>
        <HeightBox height={10} />
        <Typography style={{ fontSize: '16px', color: 'black' }} gutterBottom>
          Hard Skills
        </Typography>
        {renderHardSkills()}

          <ReactQuill
            value={formValues?.otherQualification?.hardSkills || ''}
            onChange={(value) => handleInputChange(value, 'hardSkills')}
            // modules={modules}
            // formats={formats}
          />
       
      </Grid>
      </Grid>
      {/* Educational Qualification */}
      <Grid container spacing={2}>
        <Grid item xs={12}>

          <HeightBox height={10}/>

          <Box    
              sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
            >
                <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
                Educational Qualifications (Case Sensitive)
              </Typography>
        </Box>
        </Grid>
          {formValues?.educationalQualification?.map((qualification, index) => (
            <React.Fragment key={index}>
              <Grid item xs={6}>
              <CustomSelect
              options={options.examinations}
              name="examination"
              fetchOptions={fetchOptions}
              value={qualification.examination}
              onChange={(e) => handleChange(e, index, 'educationalQualification')}
              fieldName="examinations"
            />
              </Grid>
              <Grid item xs={6}>
              <CustomSelect
              options={options.streams}
              name="stream"
              fetchOptions={fetchOptions}
              value={qualification.stream}
              onChange={(e) => handleChange(e, index, 'educationalQualification')}
              fieldName="streams"
            />
  
            </Grid>

              <Grid item xs={6}>
                <TextField
                  name="year"
                  size='small'
                  label="Year"
                  value={qualification.year}
                  onChange={(e) => handleChange(e, index, 'educationalQualification')}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                {index === formValues.educationalQualification.length - 1 && (
                  <Button
                    variant="contained"
                    size='small'
                    color="primary"
                    onClick={() => handleAddItem('educationalQualification')}
                  >
                    +
                  </Button>
                )}
                {index !== formValues.educationalQualification.length - 1 && (
                  <Button
                    variant="contained"
                    size='small'
                    color="secondary"
                    onClick={() => handleRemoveItem(index, 'educationalQualification')}
                  >
                    -
                  </Button>
                )}
              </Grid>
            </React.Fragment>
          ))}
        <Grid item xs={12}>
          <HeightBox height={10}/>
          <ReactQuill
        value={formValues?.otherQualification?.educationalQualification}
        onChange={value => handleInputChange(value, 'educationalQualification')}
        />
        </Grid>
      </Grid>


    {/* Higher Educational Qualification */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeightBox height={10} />
          <Box sx={{ backgroundColor: '#07519d', color: 'white', padding: '10px', opacity: 1 }}>
            <Typography style={{ fontSize: '16px', color: 'white' }} gutterBottom>
              Higher Educational Qualifications (Case Sensitive)
            </Typography>
          </Box>
        </Grid>
        {formValues?.higherEducationalQualification?.map((qualification, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
            <CustomSelect
                options={options.prefix}
                name="prefix"
                fetchOptions={fetchOptions}
                value={qualification.prefix}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fieldName="prefix"
              />
            </Grid>
        
            {/* <Grid item xs={6}>
              <CustomSelect
                options={options.courses}
                name="course"
                fetchOptions={fetchOptions}
                value={qualification.course}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fieldName="courses"
              />
            </Grid> */}
            <Grid item xs={6}>
              <CustomSelect
                options={options.universities}
                name="university"
                fetchOptions={fetchOptions}
                value={qualification.university}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fieldName="universities"
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                name="location"
                size='small'
                label="location"
                value={qualification.location}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="start"
                size='small'
                label="Start"
                value={qualification.start}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="complete"
                size='small'
                label="End"
                value={qualification.complete}
                onChange={(e) => handleChange(e, index, 'higherEducationalQualification')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              {index === formValues.higherEducationalQualification.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="primary"
                  onClick={() => handleAddItem('higherEducationalQualification')}
                >
                  +
                </Button>
              )}
              {index !== formValues.higherEducationalQualification.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="secondary"
                  onClick={() => handleRemoveItem(index, 'higherEducationalQualification')}
                >
                  -
                </Button>
              )}
            </Grid>
          </React.Fragment>
        ))}

        <Grid item xs={12}>
          <HeightBox height={10} />
          <ReactQuill
            value={formValues?.otherQualification?.higherEducationalQualification}
            onChange={value => handleInputChange(value, 'higherEducationalQualification')}
          />
        </Grid>
      </Grid>

      {/* ============================================== */}
      {/* Professional Qualification */}
      <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeightBox height={10}/>
        <Box    
            sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
          >
              <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
              Professional Qualifications (Case Sensitive)
            </Typography>
        </Box>
        </Grid>
        {formValues.professionalQualification.map((qualification, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
            <CustomSelect
              options={options.professionalCourses}
              name="course"
              fetchOptions={fetchOptions}
              value={qualification.course}
              onChange={(e) => handleChange(e, index, 'professionalQualification')}
              fieldName="professionalCourses"
            />
            </Grid>
            <Grid item xs={6}>
            <CustomSelect
              options={options.professionalUniversities}
              name="university"
              fetchOptions={fetchOptions}
              value={qualification.university}
              onChange={(e) => handleChange(e, index, 'professionalQualification')}
              fieldName="professionalUniversities"
            />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="location"
                size='small'
                label="location"
                value={qualification.location}
                onChange={(e) => handleChange(e, index, 'professionalQualification')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="start"
                size='small'
                label="Start"
                value={qualification.start}
                onChange={(e) => handleChange(e, index, 'professionalQualification')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="complete"
                size='small'
                label="End"
                value={qualification.complete}
                onChange={(e) => handleChange(e, index, 'professionalQualification')}
                fullWidth
              />
            </Grid>
            {/* Add more fields for start and complete */}
            <Grid item xs={12}>
              {index === formValues.professionalQualification.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="primary"
                  onClick={() => handleAddItem('professionalQualification')}
                >
                  +
                </Button>
              )}
              {index !== formValues.professionalQualification.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="secondary"
                  onClick={() => handleRemoveItem(index, 'professionalQualification')}
                >
                  -
                </Button>
              )}
            </Grid>
          </React.Fragment>
        ))}
        <Grid item xs={12}>
          <HeightBox height={10}/>
          <ReactQuill
          value={formValues?.otherQualification?.professionalQualification}
          onChange={value => handleInputChange(value, 'professionalQualification')}
          />
        </Grid>
      </Grid>

       {/* ============================================== */}
      {/* Professional Memberships */}
      <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeightBox height={10}/>
        <Box    
            sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
          >
              <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
              Professional Memberships (Case Sensitive)
            </Typography>
        </Box>
        </Grid>
        {formValues?.professionalMembership?.map((qualification, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
            <CustomSelect
              options={options.professionalMemberships}
              name="membership"
              fetchOptions={fetchOptions}
              value={qualification.membership}
              onChange={(e) => handleChange(e, index, 'professionalMembership')}
              fieldName="professionalMemberships"
            />
            </Grid>
            <Grid item xs={6}>
            <CustomSelect
              options={options.professionalMembershipInstitutes}
              name="institute"
              fetchOptions={fetchOptions}
              value={qualification.institute}
              onChange={(e) => handleChange(e, index, 'professionalMembership')}
              fieldName="professionalMembershipInstitutes"
            />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="number"
                size='small'
                label="Membership Number"
                value={qualification.number}
                onChange={(e) => handleChange(e, index, 'professionalMembership')}
                fullWidth
              />
            </Grid>
          
            {/* Add more fields for start and complete */}
            <Grid item xs={12}>
              {index === formValues.professionalMembership.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="primary"
                  onClick={() => handleAddItem('professionalMembership')}
                >
                  +
                </Button>
              )}
              {index !== formValues.professionalMembership.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="secondary"
                  onClick={() => handleRemoveItem(index, 'professionalMembership')}
                >
                  -
                </Button>
              )}
            </Grid>
          </React.Fragment>
        ))}
        {/* {
          !formValues.professionalMembership && (
            <Button
                  variant="contained"
                  size='small'
                  color="primary"
                  onClick={() => handleAddItemFirst('professionalMembership')}
                >
                  +
                </Button>
          )
        } */}
        <Grid item xs={12}>
          <HeightBox height={10}/>
          <ReactQuill
          value={formValues?.otherQualification?.professionalMembership}
          onChange={value => handleInputChange(value, 'professionalMembership')}
          />
        </Grid>
        
      </Grid>
        
      {/* ============================================== */}
      {/* Work Experience */}
      <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeightBox height={10}/>
        <Box    
            sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
          >
              <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
              Work Experience (Case Sensitive)
            </Typography>
        </Box>
        </Grid>
        {formValues.workExperience.map((experience, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
              <TextField
                name="company"
                size='small'
                label="Company"
                value={experience.company}
                onChange={(e) => handleChange(e, index, 'workExperience')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="location"
                size='small'
                label="Location"
                value={experience.location}
                onChange={(e) => handleChange(e, index, 'workExperience')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
            <CustomSelect
              options={options.designations}
              name="designation"
              fetchOptions={fetchOptions}
              value={experience.designation}
              onChange={(e) => handleChange(e, index, 'workExperience')}
              fieldName="designations"
            />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="start"
                size='small'
                label="Start Year"
                value={experience.start}
                onChange={(e) => handleChange(e, index, 'workExperience')}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="complete"
                size='small'
                label="End Year"
                value={experience.complete}
                onChange={(e) => handleChange(e, index, 'workExperience')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
            
               <ReactQuill
                name='description'
                value={experience.description}
                onChange={(value) => handleChangeExperienceDescription(index,value)}
                />
            </Grid>
            {/* Add more fields for end and description */}
            <Grid item xs={12}>
              {index === formValues.workExperience.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="primary"
                  onClick={() => handleAddItem('workExperience')}
                >
                  +
                </Button>
              )}
              {index !== formValues.workExperience.length - 1 && (
                <Button
                  variant="contained"
                  size='small'
                  color="secondary"
                  onClick={() => handleRemoveItem(index, 'workExperience')}
                >
                  -
                </Button>
              )}
            </Grid>
          </React.Fragment>
        ))}

        <Grid item xs={12}>
          <HeightBox height={10}/>
          <ReactQuill
          value={formValues?.otherQualification?.workExperience}
          onChange={value => handleInputChange(value, 'workExperience')}
          />
        </Grid>
      </Grid>

      {/* Summary of Career */}
      <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeightBox height={10}/>
        <Box    
            sx={{ backgroundColor: '#07519d ', color: 'white', padding: '10px', opacity: 1 }}
          >
              <Typography style={{fontSize:'16px',color:'white'}} gutterBottom>
              Career Summary
            </Typography>
        </Box>
        </Grid>
       <Grid item xs={6}>
        <TextField
          name="totalYearsOfExperience"
          size='small'
          label="Total Years of Experience"
          value={formValues.personalInfo.totalYearsOfExperience}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        />
        </Grid>
    
        <Grid item xs={6}>
          <TextField
            name="itLiteracy"
            size='small'
            label="IT Literacy (ALL CAPITAL LETTERS)"
            value={formValues.personalInfo.itLiteracy}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            name="currentLocation"
            size='small'
            label="Current Location (ALL CAPITAL LETTERS)"
            value={formValues.personalInfo.currentLocation}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>

        <Grid item xs={3}>
        <TextField
          name="currentSalaryPackageCurrency"
          size="small"
          label="Currency"
          value={formValues.personalInfo.currentSalaryPackageCurrency}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        />
      </Grid>
        <Grid item xs={3}>
        <TextField
          name="currentSalaryPackage"
          size="small"
          label="Current Salary Package"
          value={formValues.personalInfo.currentSalaryPackage}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        />
      </Grid>

      <Grid item xs={3}>
        <TextField
          name="expectedSalaryPackageCurrency"
          size="small"
          label="Currency"
          value={formValues.personalInfo.expectedSalaryPackageCurrency}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        />
      </Grid>
      
      <Grid item xs={3}>
        <TextField
          name="expectedSalaryPackage"
          size="small"
          label="Expected Salary Package"
          value={formValues.personalInfo.expectedSalaryPackage}
          onChange={(e) => handleChange(e, null, 'personalInfo')}
          fullWidth
        />
      </Grid>
      
      <Grid item xs={6}>
          <TextField
            name="professionalSummary"
            size='small'
            label="Professional Summary (Auto Generated)"
            multiline
            value={formValues.personalInfo.professionalSummary}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>

        <Grid item xs={6} style={{paddingBottom:20}}>
          <TextField
            name="interestedToWork"
            size='small'
            label="Applied Country (ALL CAPITAL LETTERS)"
            value={formValues.personalInfo.interestedToWork}
            onChange={(e) => handleChange(e, null, 'personalInfo')}
            fullWidth
          />
        </Grid>
      </Grid>

      {/* Submit button */}
      {/* <Button type="submit" variant="contained" color="primary">
        Submit
      </Button> */}
            <HeightBox height={20}/>
            <FileList files={files} nic={formValues.nic} />

      <Grid item xs={12}>
      <Button
      disabled={formValues.passportNo === ''}
      variant="contained" color="primary" onClick={sendData} >
        {formValues.passportNo === '' ? 'Please Passport No' : 'Update Profile'}
         </Button>
         
        <Button variant="contained" color="primary" onClick={handleNextStep}>
          Preview
        </Button>
      </Grid>
      </Grid>
        
      )}
    {step === 2 && (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                <Button variant="contained" onClick={handlePreviousStep}>
                  Edit Profile
                </Button>
                {/* <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button> */}
              </Grid>
              <UserProfileContainer data={formValues}/>

            
            </Grid>
    )}
    </form>

    
    </CardContent>
    }
    </Card>
    </ThemeProvider>
  );
};

export default CreateCandidateForm;
